import type { IconProps } from "./iconPropsTypes";

const RivalsBullet = ({ fill }: IconProps): React.JSX.Element => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 11 15"
    width="11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7713_12544)">
      <path d="M11 0L0 9.0267H6.78741L11 14.3V0Z" fill={fill} />
    </g>
    <defs>
      <clipPath id="clip0_7713_12544">
        <rect fill="white" height="14.3" width="11" />
      </clipPath>
    </defs>
  </svg>
);

export default RivalsBullet;
